import request from '@/utils/request'
export const getTop5GameLogList = () => {
  return request.get('/gamelogs/top5')
}
export const getGameLog = (id) => {
  return request.get(`/gamelogs/${id}`)
}
// 分页查找
export const getGameLogList = (gamelog) => {
  return request.get('/gamelogs/list', {
    params: gamelog
  })
}
export const getTop10ForBag = (id) => {
  return request.get(`/gamelogs/top10/${id}`)
}
